// eslint-disable-next-line
export const trim = value => value && value.trim();


// WEBPACK FOOTER //
// ./src/utils/field-normalize.js